import React from "react";
import { Image, Platform } from "react-native";
import { Typography, Box, Stack, Spacer, Button } from "digiwash-components";

import styled from "styled-components/native";
import Icon from "../../components/Icon";
import useNavigation from "../../hooks/useNavigation";
import { formatNumber } from "digiwash-core";

const webStyles =
  Platform.OS === "web"
    ? {
        container: {
          maxWidth: 768,
          margin: "auto",
          width: "100%",
        },
      }
    : {};

const Container = styled(Box)`
  border-bottom-right-radius: 24px;
  border-bottom-left-radius: 24px;
`;

function crossPlatformProfilePictureImport() {
  let asset = require(`../../resources/profile-picture.png`);
  return asset?.default || asset;
}

let profilePicture = crossPlatformProfilePictureImport();

interface PropTypes {
  data: any;
}

function ProfileInfo(props: PropTypes) {
  let nav = useNavigation();
  let { data } = props;

  return (
    <Container pt="xxxl">
      <Box style={webStyles.container}>
        <Stack distribution="space-between" pt="l" px="l">
          <Box>
            <Image source={profilePicture} style={{ width: 64, height: 64 }} />
          </Box>
          <Box pr="m" style={{ flexGrow: 1 }}>
            <Typography color="common.white" ff="mainBold" fs="m">
              {data?.first_name} {data?.last_name}
            </Typography>
            <Typography color="common.white" ff="mainBold" fs="xm">
              {data?.cellphone && formatNumber(data?.cellphone)}
            </Typography>
          </Box>
          <Stack>
            <Button
              onPress={() => {
                nav.navigate("EditProfile");
              }}
            >
              <Icon name="edit-2" size={24} color="common.white" />
            </Button>
            <Spacer size="l" />
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
}

export default ProfileInfo;
